import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface ISegmentState {
  segmentDetail: IObjectState<any>
}

export const prefix = "segment/segment"

export const state = (): ISegmentState => ({
  segmentDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.segmentDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: ISegmentState, data) => {
    Vue.set(state, "segmentDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.segmentDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.segmentDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(state.segmentDetail, e.response?.data || e)
      )
    }
  },
}
